import React from "react";
import Routes from "./routes/Routes";
import SentryBoundry from "././Sentry";

export default () => (
  <SentryBoundry>
    <Routes />
  </SentryBoundry>
);
